import Vue from 'vue'
import Router from 'vue-router'
import index from '../view/index.vue'
import rank from '../view/rank.vue'
import book from '../view/book.vue'
import lottery from '../view/lottery.vue'
import warm from '../view/warm.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/dsrpro2026',
  routes: [
	{
		name:'warm',
		path:'/warm',
		component:warm
	},
	{
		name:'index',
		path:'/index',
		component:index
	},
	{
		name:'rank',
		path:'/rank',
		component:rank
	},
	{
		name:'book',
		path:'/book',
		component:book
	},
	{
		name:'lottery',
		path:'/lottery',
		component:lottery
	}
  ]
})
